import MenuBar from "../components/menuBar/menuBar";
import { Outlet, useNavigate } from "react-router-dom";
import { useState } from 'react';

import Footer from "../components/footer/footer";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

import './viewer.css';

import { useGlobalContext } from "../context/globalContext";
import Footer1 from "../components/footer/footer1";

const Viewer = (props) => {
    const navigate = useNavigate();
    const [showAdVideo, setShowAdVideo] = useState(false);
    const {cartCourseId} = useGlobalContext();

    const handleCartButtonClick = () => {
        navigate("/checkout");
    };
    return(
        <div className="main_container">
            <MenuBar />
            <Outlet />
            {
                cartCourseId.length >0 ?
                <button
                type="button"
                className="btn btn-primary cart-button primary-button position-fixed bottom-0 end-0 m-4"
                style={{ zIndex: 1050 }} onClick={() => {handleCartButtonClick()}}>
                        <ShoppingCartOutlinedIcon />
                        <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                        <span className="visually-hidden">New alerts</span>
                    </span>
                </button>:<></>
            }
            {showAdVideo && (
                <div 
                    className="video-ad-container position-fixed bottom-0 start-0 m-4 bg-dark rounded shadow"
                    style={{ zIndex: 1049}}
                >
                    <div className="d-flex justify-content-end">
                        <button 
                            onClick={() => setShowAdVideo(false)} 
                            className="btn-close btn-close-white m-2"
                            aria-label="Close"
                        />
                    </div>
                    <video 
                        width="100%" 
                        height="50rem" 
                        controls 
                        autoPlay 
                        muted 
                        className="rounded-bottom"
                    >
                        <source src="/videos/teachers_day.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            )}
            <Footer1 />
        </div>
    ) 
}

export default Viewer;